<template>
  <div v-if="isVisable" class="modal-overlay">
    <div class="modal">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isVisable: false,
    returnFocusTo: null, // 웹접근성 : modal close 시점에 되돌아갈 focus 저장용 변수
  }),
  methods: {
    open() {
      // 모달이 열리기 직전 포커스 위치 저장
      this.returnFocusTo = document.activeElement;

      this.isVisable = true;

      this.$nextTick(() => {
        this.getFocusableElements()[0]?.focus()
      });

      document.addEventListener('keydown', this.handleKeydown);
    },
    close() {
      this.isVisable = false;

      // DOM 업데이트가 끝난 후, 저장해둔 요소로 포커스를 되돌린다
      this.$nextTick(() => {
        if (this.returnFocusTo) {
          this.returnFocusTo.focus();
        }
        this.returnFocusTo = null; // 초기화
      });

      //모달이 닫히면 키보드 이벤트 리스너 제거
      document.removeEventListener('keydown', this.handleKeydown);
    },
    // 포커스 가능한 모든 요소를 찾는 헬퍼 메서드
    getFocusableElements() {
      const focusableSelector = [
        'a[href]:not([tabindex="-1"])',
        'button:not([disabled]):not([tabindex="-1"])',
        'input:not([disabled]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])'
      ].join(', ');

      // this.$el은 이 컴포넌트의 루트 DOM 요소를 가리킴 (즉, <Modal> 컴포넌트)
      // NodeList를 실제 배열로 변환하여 반환
      return Array.from(this.$el.querySelectorAll(focusableSelector))
                  .filter(el => el.offsetParent !== null); // 화면에 실제로 보이는 요소만 필터링
    },

    // Tab 키 이벤트 처리
    handleKeydown(e) {
      if (e.key !== 'Tab') return;

      // 호출되는 시점에 포커스 가능한 요소 목록을 가져옴 (v-if 대응)
      const focusableElements = this.getFocusableElements();
      if (focusableElements.length === 0) return; // 포커스할 요소가 없으면 종료

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      // Shift + Tab (역방향)
      if (e.shiftKey) {
        // 현재 포커스가 첫 번째 요소에 있다면, 마지막 요소로 강제 이동
        if (activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      }
      // Tab (정방향)
      else {
        // 현재 포커스가 마지막 요소에 있다면, 첫 번째 요소로 강제 이동
        if (activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeydown);
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: white;
  padding: 3px;
  padding-bottom: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  width: 700px;
}
</style>